/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEdit = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M17.667 2 22 6.333 6.333 22H2v-4.333zm-3.653 6.429L3.963 18.48v1.557H5.52L15.57 9.985zm3.653-3.653L15.43 7.014l1.556 1.556 2.239-2.237z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgEdit as Edit };
